import { render, staticRenderFns } from "./CadastroPageActions.vue?vue&type=template&id=9ef0534a&scoped=true&lang=pug&"
import script from "./CadastroPageActions.vue?vue&type=script&lang=js&"
export * from "./CadastroPageActions.vue?vue&type=script&lang=js&"
import style0 from "./CadastroPageActions.vue?vue&type=style&index=0&id=9ef0534a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ef0534a",
  null
  
)

export default component.exports